<template>

<div
  class="image-item"
  v-on:mousedown.prevent
  v-on:click.prevent
>
  <Image :src="image" />
</div>

</template>

<script>
// import svgImage from '@/svg/svgImage'

export default {
  props: [
    'image'
  ],
  components: {
    // svgImage,
  }
}
</script>

<style lang="scss" scoped>

.image-item {
  cursor: pointer;
  flex: none;
  width: 148px;
  height: 148px;
  margin: 0 10px 0 0;
  border-radius: 8px;
  background-color: var(--gray-400);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    object-fit: cover;
    object-position: center bottom;
    transition: 200ms transform;
  }

  svg {
    display: block;
    margin: auto;
    width: 30%;
    height: auto;
    fill: var(--gray-300);
  }

  &:hover {
    background-color: #A1A1A1;
    svg {
      fill: #BFBFBF;
    }
    img {
      transform: translate3d(-50%, -50%, 0) scale(1.1);
    }
  }
  &:active {
    background-color: #858585;
    svg {
      fill: #9D9D9D;
    }
  }

  &:last-child {
    margin: 0;
  }
  @media screen and (max-width: 940px) {
    width: 120px;
    height: 120px;
  }

  @media screen and (max-width: 940px) {
    width: 180px;
    height: 180px;
  }
  @media screen and (max-width: 730px) {
    width: 160px;
    height: 160px;
  }
  // @media screen and (max-width: 730px) {
  //   width: 160px;
  //   height: 160px;
  // }
}


</style>